export enum Exceptions {
    NO_ROLE_AUTHORIZED = 403,
    UNPROCESSABLE_CONTENT_ERROR_CODE = 422,
    UNAUTHORIZED_ERROR_CODE = 401,
    INTERNAL_SERVER_ERROR = 500
}
